<template lang="pug">
.view-platforms.content
  ui-navbar-panel(title="Управление платформами")
    router-link(:to="{ name: 'newPlatform' }")
      b-button(type="is-primary", icon-left="plus-circle") Новая платформа

  div.columns
    div.column.is-two-thirds-desktop.is-full-tablet
      b-table(
        :data="platforms.items",
        :loading="platforms.$state.loading",
        detail-key="id",
        default-sort="name",
        @click="routeToPlatform",
        hoverable
      )
        //- Row
        b-table-column(field="id", label="ID", width="1", nowrap, sortable, numeric v-slot="{row}")
          | {{ row.id }}

        b-table-column(field="status", label="Статус", width="1", nowrap, sortable v-slot="{row}")
          //-b-tag(:type="`is-rounded ${row.statusLabel.color}`")
          b-tooltip(:label="row.statusLabel.name")
            b-icon(v-if="row.$state.loading", icon="loading", type="is-grey", custom-class="mdi-spin")
            b-icon(v-else, :icon="row.statusLabel.icon", :type="row.statusLabel.color")

        b-table-column(field="priority", label="Приоритет", width="1", nowrap, sortable, numeric v-slot="{row}")
          platform-priority-icon(:value="row.priority")

        b-table-column(field="name", label="Название", sortable v-slot="{row}")
          | {{ row.name }}

        b-table-column(field="label", label="Тип", sortable v-slot="{row}")
          ui-label.mr-5(v-if="row.label", :label="row.label", is-rounded)

        b-table-column(field="host", label="URL", sortable v-slot="{row}")
          a.tag.is-info(:href="`https://${row.host}`", target="_blank")
            span {{ row.host }}
            b-icon(icon="arrow-top-right-thick", size="is-small")

        b-table-column(field="server_id", label="Сервер", nowrap, sortable v-slot="{row}")
          b-tooltip(v-if="row.isActiveServer", :label="row.server.status_label")
            b-icon(icon="check", type="is-success")
          b-tooltip(v-else-if="row.server", :label="row.server.status_label")
            b-icon(icon="close", type="is-danger")
          | {{ row.server ? row.server.name : '' }}

</template>

<script>
import Platform from '@/models/Platform';

export default {
  name: 'view-platforms',

  data: () => ({
    platforms: Platform.collection(),
  }),

  methods: {
    loadPlatforms() {
      this.platforms.$fetch({
        include: 'label,server',
        // filter: { status: 'ne:0' },
      });
    },

    routeToPlatform({ id }) {
      this.$router.push({ name: 'editPlatform', params: { id } });
    },
  },

  created() {
    this.loadPlatforms();
  },
};
</script>
